import { render } from "./ComponenteLoading.vue?vue&type=template&id=db016b06&scoped=true"
import script from "./ComponenteLoading.vue?vue&type=script&lang=js"
export * from "./ComponenteLoading.vue?vue&type=script&lang=js"

import "./ComponenteLoading.vue?vue&type=style&index=0&id=db016b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db016b06"]])

export default __exports__